export default __webpack_public_path__ + "b2de2516ec331e654c58b0eaa6a50850.png";